import { QUERY_KEY } from '@constants/queries';

import { useQuery } from '@tanstack/react-query';
import { GET } from '@lib/axios';
import { News } from '@utils/typesPages/types';
import { CACHE_TIME_TANSTACK } from '@constants/configurations';

export const fetchNewsBySlug = async (slug: string) => {
  const { data } = await GET<News>(`/api/news/${slug}`);

  return data;
};

export const useFetchNewsBySlug = (slug: string) => {
  return useQuery({
    queryKey: [QUERY_KEY.FETCH_NEWS_BY_SLUG, slug],
    queryFn: () => fetchNewsBySlug(slug),
    enabled: !!slug,
    refetchInterval: CACHE_TIME_TANSTACK,
    gcTime: CACHE_TIME_TANSTACK,
  });
};
